import { toast } from 'react-toastify';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

import { getCustomDocumentQueryAnalytics } from '../../../../../services/ai';
import { fetchCustomQueriesAnalyticsFailed, fetchCustomQueriesAnalyticsStarted, fetchCustomQueriesAnalyticsSuccessful } from './actions';
import { AdminAIChatbotActionTypes, CustomDocumentQueryAnalytics } from './types';

export function* attemptFetchCustomQueryAnalytics({ payload }: ReturnType<typeof fetchCustomQueriesAnalyticsStarted>) {
    try {
        const analytics: CustomDocumentQueryAnalytics = yield call(getCustomDocumentQueryAnalytics, payload);
        yield put(fetchCustomQueriesAnalyticsSuccessful(analytics));
    } catch (e) {
        yield put(fetchCustomQueriesAnalyticsFailed((e as Error).message));
        toast.error('We encountered a problem fetching the analytics, please try again.');
    }
}

function* attemptFetchCustomQueryAnalyticsWatcher() {
    yield takeLatest(AdminAIChatbotActionTypes.FETCH_CUSTOM_QUERY_ANALYTICS_STARTED, attemptFetchCustomQueryAnalytics);
}

export function* adminAIChatbotSaga() {
    yield all([
        fork(attemptFetchCustomQueryAnalyticsWatcher)
    ]);
}
